import { Identity } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { Injectable } from '@angular/core';
import { Task, DocumentTemplate, TaskDetails } from '../task.model';

@Injectable({
  providedIn: 'root'
})
export class TaskAdministrationService {

  constructor(private appServerAPI: AppServerAPI) { }

  public getTasks(): Observable<Task[]> {
    return this.appServerAPI.execute<Task[]>('/tmc-common/processing/task-admin', {});
  }

  public getDocuments(): Observable<DocumentTemplate[]> {
    return this.appServerAPI.execute<DocumentTemplate[]>('/tmc-common/processing/task-admin/documents', {});
  }

  public getTaskDetails(identity: Identity): Observable<TaskDetails> {
    return this.appServerAPI.execute<TaskDetails>('/tmc-common/processing/task-admin/details', identity);
  }

  public saveTask(details: TaskDetails): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/tmc-common/processing/task-admin/save', details);
  }

  public createTask(details: TaskDetails): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/tmc-common/processing/task-admin/create', details);
  }

  public deleteTask(identity: Identity): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/tmc-common/processing/task-admin/delete', identity);
  }
}
